<template>
  <div class="wrap" v-if="visible" v-drag draggable="false">
    <!-- <div v-if="webSocketMsg.status===2||webSocketMsg.status===99" class="icon-wrap">
      <img src="@/assets/call/calling2.png" class="calling-icon" alt="">
    </div> -->
    <div class="icon-wrap">
      <el-tooltip class="item" effect="dark" content="取消呼叫" placement="top-start">
        <img @click="callOutCancel" src="@/assets/call/calling2.png" class="calling-icon" alt="">
      </el-tooltip>
    </div>
    <span v-if="webSocketMsg.status==0||webSocketMsg.status==3" style="font-size: 24px;">拨号中...</span>
    <span v-else :class="webSocketMsg.status===2||webSocketMsg.status===99?'off':''">{{duration}}</span>
    <!-- <img @click="hide" v-if="sourceType !== 5" src="@/assets/call/arrow-fill.png" class="calling-icon pointer" alt=""> -->
  </div>
</template>

<script>
import WebSocketServer from '@/base/webSocket'
import { mapState } from 'vuex'
import { getPresentCallStatus, callOut, callOutCancel } from '@/views/call/api'

export default {
  name: 'callFollowupDialog',
  props: {
  },
  data () {
    return {
      visible: false,
      isStart: false, // 开始计时
      hour: 0, // 定义时，分，秒，毫秒并初始化为0；
      minute: 0,
      second: 0,
      timer: '',
      duration: '00:00:00'
    }
  },
  watch: {
    webSocketMsg: {
      handler (newV, oldV) {
        // 0:对方响铃 1：接通  2：挂断  3：座席响铃
        if (newV.status === 2) {
          this.visible = false
          this.stop()
          if (this.$route.path.includes('/zxk/reach/call/callLog')) {
            this.$bus.$emit('callOutCancel')
          }
        } else if (newV.status === 1 && newV.cno === this.seatsInfo.cnoThirdNo) {
          // 当前建立的socket信息与当前拨号信息是否一致 && newV.requestUniqueId === this.callUniqueId.id
          this.timeStart()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({ webSocketMsg: state => state.user.webSocketMsg, callUniqueId: state => state.user.callUniqueId, seatsInfo: state => state.user.seatsInfo })
  },
  methods: {
    websocket () {
      // bug：管理员在坐席管理解绑坐席，员工坐席缓存，需确保拿到最新的坐席信息
      this.$store.dispatch('queryUserCallClient').then(res => {
        if (!this.seatsInfo.cnoThirdNo) return
        // 建立webSocket
        if (!window.WebSocketServer) {
          this.WebSocketServer = new WebSocketServer()
          this.WebSocketServer.connect()
          window.WebSocketServer = this.WebSocketServer
        }
      })
    },
    stop () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    timeStart () {
      if (this.isStart && !this.timer) {
        this.timer = setInterval(this.time, 1000)
      }
    },
    time () { // 定义计时函数
      this.second = this.second + 1 // 秒
      if (this.second >= 60) {
        this.second = 0
        this.minute = this.minute + 1 // 分钟
      }
      if (this.minute >= 60) {
        this.minute = 0
        this.hour = this.hour + 1 // 小时
      }
      this.duration = this.toDub(this.hour) + ':' + this.toDub(this.minute) + ':' + this.toDub(this.second)
    },

    toHHmmss (date) {
      var time
      var hours = parseInt((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = parseInt((date % (1000 * 60)) / 1000)
      time = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)
      this.duration = time
      this.hour = hours
      this.minute = minutes
      this.second = seconds
    },

    toDub (n) { // 补0操作
      if (n < 10) {
        return '0' + n
      } else {
        return '' + n
      }
    },
    init (val) {
      this.websocket()
      clearInterval(this.timer)
      this.hour = 0 // 定义时，分，秒，毫秒并初始化为0；
      this.minute = 0
      this.second = 0
      this.timer = ''
      this.duration = '00:00:00'
      this.isStart = true
      this.visible = true
      //  0:对方响铃 1：接通  2：挂断  3：座席响铃 33：静音
      // if (this.webSocketMsg && this.webSocketMsg.status === 2) {
      this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ status: 0 }))
      // }
      if (this.callUniqueId && this.callUniqueId.id) {
        // 当前通话状态
        getPresentCallStatus({ requestUniqueId: this.callUniqueId.id }).then(res => {
          if (res.data) {
            const status = res.data.status
            if (status === 0) { // 拨号中
              this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ status: 0, cno: this.seatsInfo.cnoNo, requestUniqueId: this.callUniqueId.id }))
            } else if (status === 1) { // 通话中
              this.toHHmmss(res.data.callTimeStamp)
              this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ status: 1, cno: this.seatsInfo.cnoNo, requestUniqueId: this.callUniqueId.id }))
            }
          }
        })
      }
      var options = {
        customerNumber: val.customerNumber.replace(/-/g, ''), // 刘双桂:18226639080
        source: 200, // 臻寻客默认传200
        contactName: val.contactName
      }
      console.log(options, 111111)
      if (!options.customerNumber || options.customerNumber.includes('--')) {
        this.$message.warning('呼叫号码不正确，请更正后重新拨打')
        this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ ...this.webSocketMsg, status: 2 }))
        return
      }
      if (this.webSocketMsg.status === 1 || this.webSocketMsg.status === 33) return

      callOut(options).then(res => {
        if (res.code === '0') {
          this.$store.commit('SET_CALLUNIQUEID', { id: res.data })
        } else if (res.code === '32024') {
          // 【融营】首次拨打验证手机号
          this.$bus.$emit('vaildCallPhone')
        } else {
          this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ ...this.webSocketMsg, status: 2 }))
          this.$message.warning(res.msg)
        }
      }).catch(_ => {
        this.$store.commit('SET_WEBSOCKETMSG', JSON.stringify({ ...this.webSocketMsg, status: 2 }))
      })
    },
    callOutCancel () { // 手动挂断
      callOutCancel({ requestUniqueId: this.callUniqueId.id }).then(res => {
        if (res.code === '0') {
          this.visible = false
        } else {
          this.visible = false
          this.$message.warning(res.msg)
        }
      }).catch(e => {
        this.$message.warning(e.msg)
      })
    }
  },
  directives: {
    drag (el) {
      const oDiv = el // 当前元素
      if (!oDiv) return
      // 禁止选择网页上的文字
      oDiv.onselectstart = function () {
        return false
      }
      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disY = e.clientY - oDiv.offsetTop
        oDiv.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let t = e.clientY - disY

          // 限制滑块超出页面
          const clientHeight = document.body.clientHeight

          if (t < 0) {
            t = 0 // 固定顶部向上拖拽时消失
          } else if (t > clientHeight - oDiv.clientHeight) {
            t = clientHeight - oDiv.clientHeight
          }
          // 移动当前元素
          oDiv.style.top = t + 'px'
        }
        document.onmouseup = function (e) {
          oDiv.onmousemove = null
          document.onmouseup = null
        }
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__body {
    padding: 30px 40px 30px 30px;
  }
}
.el-select,
.el-date-editor,
.el-cascader,
.el-input {
  width: 100%;
}
.el-form-item {
  margin-bottom: 16px;
}
.remindTag-box {
  /deep/.el-tag {
    background-color: #fff;
    border-color: #1890ff;
    color: #1890ff !important;
  }
}

.calling-box {
  text-align: center;
  margin-bottom: 20px;
  i {
    font-size: 20px;
  }
}

.wrap {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  height: 56px;
  max-width: 206px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 99px 0 0 99px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 0 5px;
  .icon-wrap {
    width: 46px;
    height: 46px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .calling-icon {
    width: 24px;
    height: 24px;
  }
  .pointer {
    cursor: pointer;
  }
  span {
    padding: 0 12px 0 10px;
    font-size: 24px;
    color: #33d453;
    cursor: context-menu;
    &.off {
      color: #ff414f;
    }
  }
}
</style>
